<div class="reports">

  <div class="sidebar">
    <p-accordion multiple="true" class="reports-sidebar">
      <p-accordionTab [disabled]="true" [selected]="true">
        <p-header><span style="text-decoration: underline;">Reports</span></p-header>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == AssetInventoryReport" (click)="selectReport(AssetInventoryReport)">Asset/Inventory</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == DeviceConnectivityReport" (click)="selectReport(DeviceConnectivityReport)">Device Connectivity</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == PortDetailReport" (click)="selectReport(PortDetailReport)">Port Details</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == SoftwareReport" (click)="selectReport(SoftwareReport)">Software</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == ProcessesReport" (click)="selectReport(ProcessesReport)">Processes</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == StalePortReport" (click)="selectReport(StalePortReport)">Stale Ports</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == IpPhoneReport" (click)="selectReport(IpPhoneReport)">IP Phones (CDP/LLDP)</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == ScannedPortsReport" (click)="selectReport(ScannedPortsReport)">Scanned Ports</span>
        </div>
      </p-accordionTab>
      <p-accordionTab [disabled]="true" [selected]="true">
        <p-header><span style="text-decoration: underline;">Windows Reports</span></p-header>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == ComputerSystemsReport" (click)="selectReport(ComputerSystemsReport)">Computer Systems</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == BiosReport" (click)="selectReport(BiosReport)">BIOS</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == OperatingSystemsReport" (click)="selectReport(OperatingSystemsReport)">Operating Systems</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == ProcessorsReport" (click)="selectReport(ProcessorsReport)">Processor(s)</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == DiskDrivesReport" (click)="selectReport(DiskDrivesReport)">Disk Drive(s)</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == LogicalDisksReport" (click)="selectReport(LogicalDisksReport)">Logical Disk(s)</span>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>

  @if (!!selectedReport && (selectedReport !== ScannedPortsReport)) {
    <div class="reportSelected">
      <report-viewer [infoSetView]="selectedReportInfo"></report-viewer>
    </div>
  }
  @if (!!selectedReport && (selectedReport === ScannedPortsReport)) {
    <div class="reportSelected">
      <report-viewer [infoSetView]="selectedReportInfo" [updateCallback]="updateScannedPortsReport"></report-viewer>
    </div>
  }

  @if (!selectedReport) {
    <div class="noReportSelected">
      Select a report to view its details
    </div>
  }

</div>
